import { render, staticRenderFns } from "./CardsView.vue?vue&type=template&id=24b89595&scoped=true"
import script from "../js/Cards?vue&type=script&lang=js&external"
export * from "../js/Cards?vue&type=script&lang=js&external"
import style0 from "./CardsView.vue?vue&type=style&index=0&id=24b89595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b89595",
  null
  
)

export default component.exports